//api 设置 接口处理
import request from "@/utils/request.js";
export default {
    //3系统设置首页
    configIndex(param) {
        return request.post("merchant/Config.setup/configIndex", param, false, true);
    },
    //系统设置更新
    configIndexUpdate(param) {
        return request.post("merchant/Config.setup/configUpdate", param, false, true);
    },
    //4城市区划设置
    getCityList() {
        return request.get("merchant/Config.area/indexList", {}, false, true);
    },
    //区划信息更新
    cityUpdate(param) {
        return request.post("merchant/Config.area/dataUpdate", param, false, true);
    },
    //区划信息删除
    cityDel(param) {
        return request.post("merchant/Config.area/dataDel", param, false, true);
    },
    //5广告位列表
    getAdvertiseTypeList(param) {
        return request.post("merchant/Config.advertise/categoryList", param, false, true);
    },
    //广告位更新
    advertiseTypeUpdate(param) {
        return request.post("/merchant/Config.advertise/categoryUpdate", param, false, true);
    },
    //广告位删除
    advertiseTypeDel(param) {
        return request.post("/merchant/Config.advertise/categoryDel", param, false, true);
    },
    //广告图列表
    getAdvertiseList(param) {
        return request.post("/merchant/Config.advertise/indexList", param, false, true);
    },
    //广告图删除
    advertiseEcho(param) {
        return request.post("/merchant/Config.advertise/dataDel", param, false, true);
    },
    //广告图更新
    advertiseUpdate(param) {
        return request.post("/merchant/Config.advertise/dataUpdate", param, false, true);
    },
    //广告图回显
    advertiseIfon(param) {
        return request.post("/merchant/Config.advertise/dataInfo", param, false, true);
    },

    //6 素材分组列表
    getMediaCategoryList() {
        return request.post("merchant/Config.media/mediaCategoryList", {}, false, true);
    },
    //素材分组更新
    mediaCategoryUpdate(param) {
        return request.post("/merchant/Config.media/mediaCategoryUpdate", param, false, true);
    },
    //素材分组删除
    mediaCategoryDel(param) {
        return request.post("/merchant/Config.media/mediaCategoryDel", param, false, true);
    },
    //素材列表
    getMediaList(param) {
        return request.post("merchant/Config.media/mediaList", param, false, true);
    },
    //素材更新
    mediaUpdate(param) {
        return request.post("/merchant/Config.media/mediaUpdate", param, false, true);
    },
    //素材删除
    mediaDel(param) {
        return request.post("/merchant/Config.media/mediaDel", param, false, true);
    },
    //素材转移
    mediaRemoval(param) {
        return request.post("/merchant/Config.media/mediaRemoval", param, false, true);
    },

}